package br.com.texeratx.boardgametimeapp

import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.window.ComposeViewport
import br.com.texeratx.boardgametimeapp.core.di.initKoin
import br.com.texeratx.boardgametimeapp.core.spotify.di.spotifyJsModule
import io.github.aakira.napier.DebugAntilog
import io.github.aakira.napier.Napier

@OptIn(ExperimentalComposeUiApi::class)
fun main() {

    // Inicializa DI
    initKoin(
        extraModules = listOf(spotifyJsModule)
    ) { } // <- bloco vazio pro appDeclaration

    // Inicializa logger para Web
    Napier.base(DebugAntilog())

    ComposeViewport("root") {
        MainApp()
    }
}

